import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { Observable, Subscription } from 'rxjs';
import {Howl} from 'howler';
import * as firebase from 'firebase/app';
import {LoginItem, OrderItem} from '../main-datasource';
import { NzTableFilterFn, NzTableFilterList, NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import * as moment from 'moment';

export declare type Permission = 'denied' | 'granted' | 'default';
export interface PushNotification {
	body ? : string;
	icon ? : string;
	tag ? : string;
	data ? : any;
	renotify ? : boolean;
	silent ? : boolean;
	sound ? : string;
	noscreen ? : boolean;
	sticky ? : boolean;
	dir ? : 'auto' | 'ltr' | 'rtl';
	lang ? : string;
	vibrate ? : number[];
}


interface ColumnItem 
{
	name: string;
	sortOrder?: NzTableSortOrder;
	sortFn?: NzTableSortFn;
	listOfFilter?: NzTableFilterList;
	filterFn?: NzTableFilterFn;
}


@Injectable()
export class AuthGuardService implements CanActivate
{
	/**
	 * 
	 */
	displayData = [];
	ordersList = [];

	
	showPopup : boolean = false
	storeSearchArray = []

	startDate : Date = new Date()
	endDate : Date   = new Date()

	showStores : boolean = true;
	subscription: Subscription;

	startAt : string = ''

	listOfColumns: ColumnItem[] = 
	[
		{
			name: 'Store',
			sortOrder: null,
			sortFn: (a: OrderItem, b: OrderItem) => a.store.name.localeCompare(b.store.name),
			listOfFilter: [],
			filterFn: (list: string[], item: OrderItem) => list.some(name => item.storeId.indexOf(name) !== -1)
		},
		{
			name: 'ID',
			sortOrder: null,
			sortFn: (a: OrderItem, b: OrderItem) => a.orderId.localeCompare(b.orderId),
		},
		{
			name: 'Customer',
			sortFn: (a: OrderItem, b: OrderItem) => a.userData.name.localeCompare(b.userData.name),
		},
		{
			name: 'Area',
			sortOrder: null,
			sortFn: (a: OrderItem, b: OrderItem) => a.store.name.localeCompare(b.store.name),
			listOfFilter: [],
			// filterFn: (list: string[], item: OrderItem) => list.some(name => item.deliveryData.area.name.indexOf(name) !== -1)
		},
		{
			name: 'Amount',
			sortOrder: null,
			sortFn: (a: OrderItem, b: OrderItem) => a.totalPrice - b.totalPrice,
			listOfFilter: [
			{ text: 'Cash'      , value: 0 , byDefault: true },
			{ text: 'Visa/MC'   , value: 1 , byDefault: true },
			{ text: 'Knet'      , value: 2 , byDefault: true}
			],
			filterFn: (list: number[], item: OrderItem) => list.some(name => item.payType == (name))
		},
		{
			name: 'Date',
			sortOrder: 'descend',
			sortFn: (a: OrderItem, b: OrderItem) => a.timestamp - b.timestamp,
		},
		{
			name: 'Status',
			listOfFilter: [
			{ text: 'Pending'   , value: 0},
			{ text: 'Delivering', value: 1 },
			{ text: 'Completed' , value: 2 }
			],
			filterFn: (status: number[], item: OrderItem) => status.indexOf(item.status) !== -1
		},
		{
			name: '',
		}
	];
	/**
	 * 
	 * 
	 */

	tabIndex : number = 0
	public permission: Permission;

	private user: Observable<firebase.User>;
	private userDetails: firebase.User = null;
	public mUser : LoginItem;
	private url : string;

	public shouldPlaySound : Boolean = true;
	public isFirstTime     : Boolean = true;
	orderSubscription: Subscription;

	/**
	 *
	 *
	 *
	 */
	sound = new Howl({
		src: ['../../assets/sounds/alert.mp3']
	});

	public isSupported(): boolean {
		return 'Notification' in window;
	}

	requestPermission(): void {
		let self = this;
		if ('Notification' in window) {
		Notification.requestPermission(function(status) {
			return self.permission = status;
		});
		}else{
		}
	}

	create(title: string, options ? : PushNotification): any {
		let self = this;
		return new Observable(function(obs) {
		if (!('Notification' in window)) {
			console.log('Notifications are not available in this environment');
			obs.complete();
		}
		if (self.permission !== 'granted') {
			console.log("The user hasn't granted you permission to send push notifications");
			obs.complete();
		}
		let _notify = new Notification(title, options);
		_notify.onshow = function(e) {
			return obs.next({
			notification: _notify,
			event: e
			});
		};
		_notify.onclick = function(e) {
			return obs.next({
			notification: _notify,
			event: e
			});
		};
		_notify.onerror = function(e) {
			return obs.error({
			notification: _notify,
			event: e
			});
		};
		_notify.onclose = function() {
			return obs.complete();
		};
		});
	}

	generateNotification(source: Array < any > ): void {
		let self = this;
		source.forEach((item) => {
		let options = {
			body: item.alertContent,
			icon : '../../assets/images/logo/logo-sm.png'
		};
		let notify = self.create(item.title, options).subscribe();
		})
	}
	/**
	 *
	 *
	 *
	 */

	constructor(private authAf : AngularFireAuth, private db : AngularFireDatabase,
		private router:Router
	)
	{
		this.startDate = moment(this.startDate).subtract(15, "days").toDate();
		this.endDate = moment(this.endDate).add(1, "days").toDate();
		this.displayData = this.ordersList

		console.log("Authenticating")
		this.permission = this.isSupported() ? 'default' : 'denied';
		this.user = authAf.authState;
		this.user.subscribe(
			(user) => {
				if (user) 
				{
					this.userDetails = user;
					localStorage.setItem("userDet", JSON.stringify(this.userDetails));

					const list = this.db.list<LoginItem>('logins', ref => {
						return ref.orderByChild("uid").equalTo((user.uid));
					});

					list.snapshotChanges().subscribe(d =>
					{
						if (d.length > 0)
						{
							const data   = d[0];
							let mUser =  <LoginItem> data.payload.val();
							this.setUser(mUser);
							this.loadMoreData();
						}
					});
				} else {
					this.userDetails = null;
					localStorage.setItem("userDet", null);
				}
			}
		);
	}

	setUser(mUser : LoginItem)
	{
		this.mUser = mUser;
		localStorage.setItem("user", JSON.stringify(this.mUser));
		if(this.mUser.role.store === true)
		{
			setTimeout(() =>
			{
				this.newOrderListener()
			},
			199);
		}
	}

	newOrderListener()
	{
		if(this.mUser == undefined)
			return

		if(this.mUser.role.store !== true)
			return

		if(this.subscription != undefined)
			this.subscription.unsubscribe()

		var that = this

		let ref = this.db.list<OrderItem>('storeOrders/' + this.mUser.storeId, ref => {
		return ref.orderByChild("isNotified").equalTo(false);
		});

		this.subscription = ref.snapshotChanges().subscribe(d=>{

			if(d.length > 0)
			{
				this.requestPermission()

				let data: Array < any >= [];
				data.push({
					'title': 'Alert',
					'alertContent': 'A new order has been placed'
				});

				that.generateNotification(data);
				that.shouldPlaySound = true
				that.playSound()
			}
			else{
				that.shouldPlaySound = false;
				that.sound.stop();
			}
		});
	}

	playSound()
	{
		if(this.shouldPlaySound)
		{
			this.sound.play();
			setTimeout(() =>
			{
				this.playSound()
			}, 3999);
		}
	}

	logout()
	{
		this.authAf.signOut().then(() =>
		{
			localStorage.setItem("user", null);
			localStorage.setItem("userDet", null);
			localStorage.setItem('userStoreRole', null);
			this.mUser = null;
			this.userDetails = null;
			this.user = null;
			this.subscription = null;
			this.router.navigate(['/login']);
		});
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
	{
		const mUrl = state.url;
		this.url = mUrl.substr(mUrl.lastIndexOf('/') + 1)
		if (this.userDetails != null)
		{
			return true;
		} else 
		{
			const data = localStorage.getItem("userDet");
			if (data != "null" && data != undefined)
			{
				this.userDetails = JSON.parse(data);
				const userData = localStorage.getItem("user");
				if(userData !== "null")
				{
				this.mUser = JSON.parse(userData);
				if(this.mUser == undefined)
				{
					localStorage.setItem("user", null);
					localStorage.setItem("userDet", null);
					this.router.navigate(['/login'], {
					queryParams: {
						return: state.url
					}
					});
					return false;
				} else if(this.mUser.role.user == true) {
					localStorage.setItem("user", null);
					localStorage.setItem("userDet", null);
					this.router.navigate(['/login'], {
					queryParams: {
						return: state.url
					}
					});
					return false;
				} else if(this.mUser.role.store == true) {
					if (this.url === 'user')
					{
					this.redirectToHome();
					return false;
					} else if (this.url === 'stores') {
					//this.router.navigate(['bang'])
					this.redirectToHome();
					return false;
					} else if (this.url === 'edit-driver') {
					this.redirectToHome();
					return false;
					} else if (this.url === 'drivers') {
					this.redirectToHome();
					return false;
					} else if (this.url === 'cafe') {
					this.redirectToHome();
					return false;
					}
				}

				return true
				} else {
				this.router.navigate(['/login'], {
					queryParams: {
					return: state.url
					}
				});
				return false;
				}
			} else {
				console.log("navigating to login")
				this.router.navigate(['/login'], {
				queryParams: {
					return: state.url
					}
				});
				return false;
			}
		}
	}

	redirectToHome()
	{
		this.router.navigate(['/home']);
	}

	ngOnDestroy(): void 
	{
		if(this.subscription != undefined)
			this.subscription.unsubscribe();
		if(this.orderSubscription != undefined)
			this.orderSubscription.unsubscribe();
	}

	loadMoreData()
	{
		if(this.orderSubscription != undefined)
			this.orderSubscription.unsubscribe()

		if(this.startDate != undefined)
			this.startDate.setHours(0, 0, 0)
		if(this.endDate != undefined)
			this.endDate.setHours(0, 0, 0)

		var startString = moment(this.startDate).toDate().getTime();
		var endString   = moment(this.endDate).toDate().getTime();

		var ref = undefined
		if(this.startDate != undefined && this.endDate != undefined)
		{
			if(this.mUser.role.store)
			{
				ref = this.db.list<OrderItem>('storeOrders/' + this.mUser.storeId, ref => {
					return ref.orderByChild("timestamp").startAt(startString).endAt(endString);
				});
				this.showStores = false
				this.listOfColumns.splice(0, 1)
			} else 
			{
				ref = this.db.list<OrderItem>('orders', ref => {
					return ref.orderByChild("timestamp").startAt(startString).endAt(endString);
				});
			}
		} else 
		{
			ref = this.db.list<OrderItem>('orders');
			if(this.mUser.role.store)
			{
				this.showStores = false
				this.listOfColumns.splice(0, 1)
				ref = this.db.list<OrderItem>('storeOrders/'  + this.mUser.storeId);
			}
		}

		this.orderSubscription = ref.snapshotChanges().subscribe(d=>{

			this.ordersList = [];
			var keysList : string[] = [];
			var areaSearchArray = [];
			var areaList = [];

			d.forEach(data =>{

				var user =  <OrderItem> data.payload.val();
				if (user.payType == undefined)
					user.payType = 10
				this.ordersList.push(user);

				if(keysList.indexOf(user.storeId) == -1)
				{
					keysList.push(user.storeId)
					let val = { text: user.store.name, value: user.storeId }
					this.storeSearchArray.push(val)
				}
				if(user.deliveryData != undefined && user.deliveryData.area != undefined)
				{
					if(areaList.indexOf(user.deliveryData.area.name) == -1)
					{
						areaList.push(user.deliveryData.area.name)
						let val = { text: user.deliveryData.area.name, value: user.deliveryData.area.name }
						areaSearchArray.push(val)
					}
				}

				if(user.isNotified == undefined)
					user.isNotified = true

				if(user.isNotified == false)
					this.showPopup = true
			});

			this.listOfColumns.forEach(item => {
				if (item.name === 'Store') {
					item.listOfFilter = this.storeSearchArray;
				}
				if (item.name === 'Area') {
					item.listOfFilter = areaSearchArray;
				}
			});

			this.displayData = this.ordersList//this.tableSvc.search(this.searchInput, this.ordersList)
		});
	}

	trackByName(_: number, item: ColumnItem): string {
		return item.name;
	}
}
